// extracted by mini-css-extract-plugin
export default {"parameter":"i3gqd","name":"N8i3M","count":"cg26i"};